<template lang="pug">
div
  #annotationmMap.comAll(v-dragDiv,v-show="!actionData.isMini")
    .title.moveDragDiv
      span {{actionData.cnName}}
      i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
      i.el-icon-close(title='关闭'  @click='closeAdd')
    .nav
      notationAdd(ref='notationAdd' :type='actionData.payload' @closeAdd='closeAdd' @setCurText='setCurText' @startScreenShot='startScreenShot')
</template>

<script>
import notationAdd from "@/CommonDP/mongeView/question/notationAdd.vue";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import mongeCommon from "@/CommonDP/mongeView/common/mongeCommon";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
export default {
  components: { notationAdd },
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    hasDwg() {
      return mongeApp.model.hasDwg;
    }
  },
  mounted () {
    this.$message.success("请点击模型创建锚点");
  },
  methods: {
    // 模型截图
    async startScreenShot (call) {
      const type = this.hasDwg ? "modelDwg" : this.actionData?.payload;
      const cutpic = await mongeCommon.startScreenShot(type);
      call.callback(cutpic);
    },
    setCurText(val) {
      mongeApiMlib.setMapText(val);
    },
    miniCom() {
      this.$emit('closeCom', 'issue', true);
    },
    async closeAdd(logo) {
      if (logo) await this.$emit('openOther', logo);
      await this.$emit('closeCom', 'issue', false);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#annotationmMap{
  position: absolute;
  top: 35px;
  right: 30px;
  width: 370px;
  height: calc(100% - 90px);
  max-height: 870px;
  overflow: hidden;
  .nav{
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}
.next{
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 22px;
  height: 30px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-radius: 8px;
  line-height: 30px;
  bottom: 165px;
  cursor: pointer;
  right: 10px;
  z-index: 4;
  i{
    margin-left: 6px;
    font-size: 16px;
  }
}
</style>
